import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjaySpecimen } from '../../DjaySpecimen';
export function Level3Illustration({
  variant = 'default',
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-4096" data-mp="16ohw7k7s958n">
      
      <div className="relative w-full h-full bg-gradient-to-b from-lime-100 to-green-300 overflow-hidden" data-id="element-4097" data-mp="11r9c3e32qr4r">
        {/* Background: Sprout hill */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-4098" data-mp="soqaexb0ykk3">
          
          <circle cx="160" cy="40" r="22" fill="#FEF08A" data-id="element-4099" data-mp="nrq6ot1ndtw5" />
          <path d="M0 165 Q100 130 200 165 L200 200 L0 200 Z" fill="#4ADE80" data-id="element-4100" data-mp="2n3sv8hp4pego" />
          {/* Small sprout */}
          <path d="M100 165 L100 140" stroke="#16A34A" strokeWidth="3" strokeLinecap="round" data-id="element-4101" data-mp="2i3wt6nzzrx3r" />
          
          <path d="M100 150 Q88 142 84 150 Q92 156 100 150 Z" fill="#22C55E" data-id="element-4102" data-mp="1rfwjz0oic5mn" />
          <path d="M100 145 Q112 137 116 145 Q108 151 100 145 Z" fill="#22C55E" data-id="element-4103" data-mp="1vj2nw1o5dkpy" />
          
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-center justify-center pt-[6%]" data-id="element-4104" data-mp="1hk3ajq634s93">
          <div className="w-[60%] h-[60%] flex items-center justify-center" data-id="element-4105" data-mp="1mixs6osbgarm">
            <DjaySpecimen look={{
            variant
          }} size="hero" emotion={isUnlocked ? 'happy' : 'sleeping'} animate={animate && isUnlocked} className="w-full h-full" data-id="element-4106" data-mp="2a6xhrldw5v4m" />
            
          </div>
        </div>

        {/* Foreground: level badge */}
        {isUnlocked && <svg className="absolute inset-0 w-full h-full z-20 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-4107" data-mp="25gqvvtarkoq2">
          
            <circle cx="40" cy="40" r="18" fill="#16A34A" data-id="element-4108" data-mp="2t4qhyfx4rqyb" />
            <text x="40" y="46" textAnchor="middle" fontFamily="sans-serif" fontSize="16" fontWeight="900" fill="white" data-id="element-4109" data-mp="2xxbbrhg1e41u">
            
              3
            </text>
          </svg>}
      </div>
    </DjayIllustrationBase>;
}